import { useState, useEffect } from "react";
import styles from "./styles.module.css";

export default function Media({ condition, onChange }) {
  const [value, setValue] = useState(880);

  useEffect(() => {
    if (!isNaN(condition.value)) {
      setValue(condition.value);
    } else {
      setValue(880);
    }
  }, [condition]);

  const update = (v) => {
    if (!isNaN(parseFloat(v))) {
      setValue(parseFloat(v));
    } else {
      setValue("");
    }
  };

  const handleSave = () => {
    const _condition = { ...condition };
    _condition.value = value;
    onChange(_condition);
  };
  return (
    <div className={styles.media}>
      <div className={styles.propTitle}>Max Width</div>
      <input
        type={"number"}
        value={value}
        onBlur={handleSave}
        onChange={(e) => update(e.target.value)}
        className="input"
      />
    </div>
  );
}
